<div [class]="alertClasses" role="alert" [attr.aria-live]="type === 'error' ? 'assertive' : 'polite'">
  <div class="acs-alert__content">
    <div class="acs-alert__icon" *ngIf="showIcon" aria-hidden="true">
      {{ iconClass }}
    </div>
    
    <div class="acs-alert__text">
      <h4 class="acs-alert__title" *ngIf="title">{{ title }}</h4>
      <p class="acs-alert__message" *ngIf="message">{{ message }}</p>
      <div class="acs-alert__slot" *ngIf="!title && !message">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  
  <div class="acs-alert__actions" *ngIf="actions.length > 0 || dismissible">
    <div class="acs-alert__action-buttons" *ngIf="actions.length > 0">
      <acs-button 
        *ngFor="let action of actions"
        [variant]="action.variant || 'text'"
        size="small"
        (clicked)="onActionClick(action.action)">
        {{ action.label }}
      </acs-button>
    </div>
    
    <acs-button 
      *ngIf="dismissible"
      variant="text" 
      size="small"
      class="acs-alert__dismiss"
      (clicked)="dismiss()"
      aria-label="Dismiss alert">
      ✕
    </acs-button>
  </div>
</div>
